module.exports = __webpack_public_path__ + "img/Vinje_Journalist_og_lyriker.6e03f105.jpg";